import { ReactNode, useCallback, useState } from 'react';
import { createPortal } from 'react-dom';
import { uuid } from '@shared/util/uuid';
import { Bezel, BezelProps } from './Bezel';
import { BezelContextProvider, BezelCreator } from './BezelContext';

interface ActiveBezel extends BezelProps {
  id: string;
}

export function BezelProvider({ children }: { children: ReactNode }) {
  const [current, setCurrent] = useState<ActiveBezel>();

  // Each Bezel is keyed by id, so showing a new bezel triggers a new animation
  const bezel = useCallback<BezelCreator>(
    bezelProps => setCurrent({ ...bezelProps, id: uuid() }),
    [],
  );

  const onClose = useCallback(() => setCurrent(undefined), []);

  return (
    <BezelContextProvider value={bezel}>
      {children}
      {current && <BezelPresenter bezel={current} onClose={onClose} />}
    </BezelContextProvider>
  );
}

function BezelPresenter({ bezel, onClose }: { bezel: ActiveBezel; onClose: VoidFunction }) {
  const { id, ...bezelProps } = bezel;
  return createPortal(<Bezel key={id} {...bezelProps} onClose={onClose} />, document.body);
}
